// src/pages/Resources.jsx
export default function Resources() {
  return (
    <div className="p-10 max-w-6xl mx-auto">
      <h1 className="text-4xl font-bold mb-4">Resources</h1>
      <p>Downloadable resources and documents for churches.</p>
    </div>
  );
}
